import React from "react";
import getCurrencyDetails from "utils/getCurrencyDetails";

export default function LiteCurrencySelector({ selectedCurrency, setSelectedCurrency, nameAttribute }) {
  const currencies = [
    "USD", "EUR", "JPY", "GBP", "AUD", "CAD", 
    "CHF", "CNY", "HKD", "NZD", "AED", "INR", 
    "SGD", "KRW"
  ];

  return (
    <div className={`select-wrapper currency-dropdown currency-dropdown-${selectedCurrency}`}>
      <select
        className=""
        name={nameAttribute}
        value={selectedCurrency}
        onChange={(e) => setSelectedCurrency(e)}
      >
        {currencies.map((currency) => {
          const currencyDetails = getCurrencyDetails(currency);
          return (
            <option key={currency} value={currency}>
              {`${currencyDetails.symbol} ${currency}`}
            </option>
          );
        })}
      </select>
    </div>
  );
}
